import { Box, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
  DialogContainer,
  DialogTitle,
  DialogBody,
  LoadingSkeleton,
} from '../../../../common/components';

// Componentes para gestionar tareas
import TasksFilters from './tasks/TasksFilters';
import TasksDataTable from './tasks/TasksDataTable';
import TaskDialog from './tasks/TaskDialog';

// Hook para gestionar tareas de la plantilla
import { useTasksForTemplate } from '../hooks/useTasksForTemplate';

/**
 * Diálogo para visualizar y gestionar las tareas de una plantilla específica
 */
const TasksViewDialog = ({ open, onClose, template }) => {
  const {
    // Estados de datos
    tasks,
    isLoading,

    // Estados de diálogos
    taskDialogOpen,
    selectedTask,
    editMode,

    // Funciones de manejo
    handleCreateTask,
    handleEditTask,
    handleDeleteTask,
    handleReorderTasks,
    handleCloseTaskDialog,
    handleSaveTask,
  } = useTasksForTemplate(template?.uuid, open);

  if (!open || !template) return null;

  return (
    <>
      <DialogContainer open={open} onClose={onClose} size="fullWidth" minHeight="80vh">
        <DialogTitle component="div">
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span>Tareas de la plantilla: "{template.name}"</span>
            <IconButton onClick={onClose} size="small" sx={{ color: 'inherit' }}>
              <CloseIcon />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogBody sx={{ p: 0 }}>
          {isLoading ? (
            <LoadingSkeleton />
          ) : (
            <Box sx={{ p: 2 }}>
              <TasksFilters onCreateNew={handleCreateTask} templateType={template.template_type} />

              <TasksDataTable
                tasks={tasks}
                onEdit={handleEditTask}
                onDelete={handleDeleteTask}
                onReorder={handleReorderTasks}
                templateType={template.template_type}
              />
            </Box>
          )}
        </DialogBody>
      </DialogContainer>
      <TaskDialog
        open={taskDialogOpen}
        onClose={handleCloseTaskDialog}
        onSave={handleSaveTask}
        selectedTask={selectedTask}
        editMode={editMode}
        templateId={template?.uuid}
        templateType={template?.template_type}
        existingTasks={tasks}
      />
    </>
  );
};

export default TasksViewDialog;
